import ChangelogBox from "./ChangelogBox";
export default ChangelogBox